import styled from 'styled-components';

export default {
  m: { margin: '.8em' },
  mr: { marginRight: '.8em' },
  mlr: { marginLeft: '.8em', marginRight: '.8em' },
  mlr4: { marginLeft: '.4em', marginRight: '.4em' }
};

export const PopoutHead = styled.div`
  background: #1c3145;
  display: flex;
  padding: 12px 16px;
  font-size: 14px;
  border-radius: 6px 6px 0 0;
  color: #fff;
`;

export const ImportanceLabel = styled.div`
  font-size: 11px;
  font-weight: normal;
  border: 1px solid #fff;
  border-radius: 20px;
  padding-right: 6px;
  height: 20px;
  width: 102px;
  text-align: center;
  color: #fff;
  line-height: 20px;
  margin-left: 32px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
`;
